import React from 'react'
import { FCC } from 'types'
import { Link } from 'react-router-dom'
import { APP_STORE_URL, GOOGLE_PLAY_URL } from 'config'
import bgTexture from '../assets/bg-texture.png'
import loginHero from '../assets/login-hero.png'
// eslint-disable-next-line import/no-unresolved
import appStore from '../assets/app-store.svg'
// eslint-disable-next-line import/no-unresolved
import googlePlay from '../assets/google-play.svg'
import appIcon from '../assets/login-app-icon.png'
import AuthSlider from './AuthSlider/AuthSlider'
import '../style/index.scss'

const AuthLayout: FCC = ({ children }) => (
 <div className="auth-layout">
  <div
   className="auth-bg-texture"
   style={{ backgroundImage: `url(${bgTexture})` }}
  />
  <div className="auth-container">
   <div className="auth-left">
    <div className="auth-left-content">
     <div className="auth-header-welcome">
      <div className="welcome-pill">
       <p>Welcome To</p>
      </div>
      <h1 className="welcome-title">
       AgentRoof CRM<span className="dot">.</span>
      </h1>
     </div>

     <div className="auth-form-container">
      <div className="auth-form-wrapper">{children}</div>
      <div className="sign-up-now-text">
       Don’t Have account?{' '}
       <a
        className="text-primary"
        href="https://agentroof.com/sign-up"
        target="_blank"
        rel="noopener noreferrer"
       >
        Sign up now
       </a>
      </div>
     </div>

     <div className="auth-footer-section">
      <div className="auth-app-section">
       <div className="app-icon-wrapper">
        <img src={appIcon} alt="App Icon" />
       </div>
       <div className="app-links">
        <p>Get The App</p>
        <div className="store-buttons">
         <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="store-btn"
         >
          <img src={appStore} alt="App Store" />
         </a>
         <a
          href={GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="store-btn"
         >
          <img src={googlePlay} alt="Google Play" />
         </a>
        </div>
       </div>
      </div>
     </div>
    </div>
    <div className="auth-contact-info">
     <ul className="contact-info-list">
      <li>
       <a href="tel:+16479474978" target="_blank" rel="noopener noreferrer">
        +1 (647) 947-4978
       </a>
      </li>
      <li>
       <a
        href="mailto:info@agentroof.com"
        target="_blank"
        rel="noopener noreferrer"
       >
        info@agentroof.com
       </a>
      </li>
      <li>
       <a
        href="https://www.agentroof.com"
        target="_blank"
        rel="noopener noreferrer"
       >
        www.agentroof.com
       </a>
      </li>
      <li>
       <a href="mailto:support@agentroof.com">support@agentroof.com</a>
      </li>
     </ul>
    </div>
   </div>

   <div className="auth-right">
    <div className="hero-image-wrapper">
     <AuthSlider />
    </div>
   </div>
  </div>
 </div>
)

export default AuthLayout
